import DOMPurify from "dompurify";

/**
 * Sanitize HTML content for safe rendering with dangerouslySetInnerHTML.
 * Only allows a safe subset of HTML tags and attributes.
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "b", "i", "u",
      "a", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6",
      "blockquote", "span", "div", "sub", "sup",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
  });
};
